"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSnackbarSystemData = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var _useReduxSubscription = require("../useReduxSubscription");
var _configureStore = require("../configureStore");
/**
 * @returns an automatically updating state depending on the store changes in react redux.
 */
var getSnackbarSystemData = function getSnackbarSystemData() {
  var _useState = (0, _react.useState)(_configureStore.mainStore.getState()['VNSnackbarSystem'].get('snackbarData')),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    snackbarData = _useState2[0],
    setSnackbarData = _useState2[1];
  (0, _useReduxSubscription.useReduxSubscription)(function () {
    var newState = _configureStore.mainStore.getState()['VNSnackbarSystem'].get('snackbarData');
    setSnackbarData(newState);
  });
  return snackbarData;
};
exports.getSnackbarSystemData = getSnackbarSystemData;